import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import React from 'react'


export const ConfirmModal = ({
    openConfirmModal,
    handleCloseConfirmModal,
    handleConfirm,
    title,
    description,
    cancelButtonText,
    confirmButtonText,
    isLoading
}: {
    openConfirmModal: boolean,
    handleCloseConfirmModal?: () => void,
    handleConfirm?: () => void,
    title: string,
    description: string,
    cancelButtonText?: string,
    confirmButtonText?: string,
    isLoading?: boolean
}) => {
    return <Dialog
        open={openConfirmModal}
        onClose={handleCloseConfirmModal}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
    >
        <DialogTitle id="confirm-dialog-title">
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="confirm-dialog-description">
                {description}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            {handleCloseConfirmModal && (
                <Button onClick={handleCloseConfirmModal} color="primary" disabled={isLoading}>
                    {cancelButtonText}
                </Button>
            )}
            {handleConfirm && (
                <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus disabled={isLoading}>
                    {isLoading ? 'Sauvegarde en cours...' : (confirmButtonText || 'OK')}
                </Button>
            )}
        </DialogActions>
    </Dialog>
}
